/*
 * takes multiple function through spread operator arguments
 * and returns a function (currying) which is a composition
 * of all passed functions
 *
 * internally, calls each passed function in succession passing it
 * the return value from the previous function before eventually
 * returning the return value from the last function call
 *
 * compose(removeWhiteSpaces, uppercase)('hello world') -> 'HELLOWORLD'
 *
 * in the example above 'removeWhiteSpaces' is assumed to be a function
 * which removes white spaces and 'uppercase' is assumed to be a function
 * which uppercases all characters in a string
 */

module.exports = function compose(...fns) {
  if (fns.length === 0) { return arg => arg }

  if (fns.length === 1) {
    return fns[0]
  }

  return fns.reduce(
    (a, b) => (...args) => b(a(...args))
  )
}
